import { render, staticRenderFns } from "./OpenBankingPaymentModal.vue?vue&type=template&id=c2e854d4"
import script from "./OpenBankingPaymentModal.vue?vue&type=script&lang=js"
export * from "./OpenBankingPaymentModal.vue?vue&type=script&lang=js"
import style0 from "./OpenBankingPaymentModal.vue?vue&type=style&index=0&id=c2e854d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports